
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUSplittingGrid extends _Ext.GridBase<SKUSplittingRow, any> {
        protected getColumnsKey() { return 'Inventory.SKUSplitting'; }
        protected getDialogType() { return SKUSplittingDialog; }
        protected getIdProperty() { return SKUSplittingRow.idProperty; }
        protected getInsertPermission() { return SKUSplittingRow.insertPermission; }
        protected getLocalTextPrefix() { return SKUSplittingRow.localTextPrefix; }
        protected getService() { return SKUSplittingService.baseUrl; }
        public rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(52);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[52].AutoPosting;
          
            var userDefinition = Q.Authorization.userDefinition;
     
            this.editItem(<SKUSplittingRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                TransDate: now.toDateString(),
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 52,
                AutoPosting: autoposting 
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}